import accordion from "./components/accordion";
import animBorderRadiant from "./components/anim-border-radiant";
import animElements from "./components/anim-elements";
import leafletMap from "./components/leaflet-map";
import swiperPosts from "./components/swiper-posts";

swiperPosts.init();
animBorderRadiant.init();
accordion.init();
leafletMap.init();
animElements.init();
// Chargement du loader
const loader = document.getElementById('loader-wrapper');
const navBloc = document.querySelector('.navigation');
const home = document.querySelector('.home');
const footer = document.querySelector('.footer');



// if(loader) {
//     window.addEventListener('load', function() {
    
//         setTimeout(() => {
//             loader.classList.add('fade');
//             navBloc.classList.remove('fade');
//             home.classList.remove('fade');
//             footer.classList.remove('fade');
//         }, 1000)
//     })
// }

if(loader) {
    setTimeout(() => {
    
        loader.classList.add('fade');
    
        navBloc.classList.remove('fade');
        home.classList.remove('fade');
        footer.classList.remove('fade');
    }, 1000);
}

var navResp = document.querySelector('.navigation-responsive')
var btnBurger = document.querySelector('.menu-burger');
var btnClose = document.querySelector('.btn-close');

btnBurger.addEventListener('click', () => {
    navResp.classList.add('active');
    document.body.style.overflow = "hidden";

})

btnClose.addEventListener('click', () => {
    navResp.classList.remove('active');
    document.body.style.overflow = "visible";
    document.body.style.height = "unset";

})



const documentHeight = () => {
    const doc = window.innerHeight;

    const headerHome = document.querySelector('.header-home');
    if(headerHome) {
        headerHome.style.height = doc+'px'
    }

    // Ajout du menu responsive
    const menuResponsive = document.querySelector('.navigation-responsive');
    menuResponsive.style.height = doc+'px'
}

window.addEventListener('resize', documentHeight)
documentHeight()

